import { Button, Empty } from "antd";
import React, {useEffect} from "react";
import ReactGA from 'react-ga4';


export default function EmptyPage({ accion }){
    const ANALYTICS_KEY = process.env.REACT_APP_GOOGLE_ANALYTICS_KEY;
    ReactGA.initialize(ANALYTICS_KEY);

    useEffect(() => {
      ReactGA.send({ 
        hitType: "pageview",
        page: window.location.pathname 
      }); 
    }, []);

    return <Empty
    style={{ backgroundColor: "black", height: "100vh", width: "100vw", margin: "0px", padding: "0px" }}
    //image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
    image="./inmersial.svg"
    imageStyle={{ height: "50%" }}
    description={
      <span>
        {/* Cree una Nueva Experiencia <a href="#tutorial">Griftin 360°</a> */}
      </span>
    }
  >
    <Button type="primary" onClick={() => {
      accion(true);
      ReactGA.event({
        category: 'User', 
        action: 'Clicked New' 
      })
    }}>
      Crear Nueva Experiencia
    </Button>
  </Empty>
}